import { ActionProgressContainer, ActionTrack, ActionProgress } from './Styles'

type ActionProgressBarProps = {
  paused: boolean
}

const ActionProgressBar = ({ paused }: ActionProgressBarProps) => (
  <ActionProgressContainer>
    <ActionTrack />
    <ActionProgress paused={paused} />
  </ActionProgressContainer>
)

export default ActionProgressBar
